export enum Token {
  // eslint-disable-next-line
  GKAB = 'gkab',
  // eslint-disable-next-line
  KAB = 'kab',
  // eslint-disable-next-line
  GOKG = 'gokg',
  // eslint-disable-next-line
  OKG = 'okg',
}